import { z } from 'zod';

// Query for the per-branch (legal-entity) headcount + attendance report.
// `from`/`to` are inclusive YYYY-MM-DD bounds on the attendance range;
// legalEntityId narrows to a single branch. Mirrors the supplier report's
// query shape.
export const LegalEntityReportQuerySchema = z.object({
  from: z.string().date().optional(),
  to: z.string().date().optional(),
  legalEntityId: z.string().optional(),
});
export type LegalEntityReportQuery = z.infer<typeof LegalEntityReportQuerySchema>;
